import { FileUploadedSchema, type FileUploadedType } from "@validereinc/domain";
import { z } from "zod";

const FileUploadedArraySchema = z.array(FileUploadedSchema);

export const getFileEntriesFromAnswerValue = (
  value: unknown
): FileUploadedType[] | null => {
  if (Array.isArray(value)) {
    const parsedFileArray = FileUploadedArraySchema.safeParse(value);

    return parsedFileArray.success && parsedFileArray.data.length > 0
      ? parsedFileArray.data
      : null;
  }

  const parsedSingleFile = FileUploadedSchema.safeParse(value);

  return parsedSingleFile.success ? [parsedSingleFile.data] : null;
};

export const getFetchedFileUriCacheKey = ({
  sectionId,
  answerId,
  answerInstanceIndex,
  fileIndex,
}: {
  sectionId: string | undefined;
  answerId: string | undefined;
  answerInstanceIndex: number;
  fileIndex: number;
}): string => `${sectionId}-${answerId}-${answerInstanceIndex}-${fileIndex}`;
